import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import baseTheme, { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    backgroundColor = "backgroundColor",
}

interface OwnProps extends WidgetProps {
    fields: { [fields.backgroundColor]: string };
}

const mapStateToProps = (state: ApplicationState, props: OwnProps) => {};

type Props = ReturnType<typeof mapStateToProps> & OwnProps & HasHistory;

export interface FullWidthContentAreaStyles {
    container?: InjectableCss;
    wrapper?: InjectableCss;
}

export const fullWidthContentAreaStyles: FullWidthContentAreaStyles = {
    container: {
        css: css`
            text-align: center;
            display: block;
            padding: 15px 0px;
            margin-bottom: 15px;
            margin-left: calc(-50vw + 50%);
            margin-right: calc(-50vw + 50%);
        `,
    },
    wrapper: {
        css: css`
            margin: auto;
            padding: 25px 0px;
            ${({ theme }: { theme: BaseTheme }) => {
                const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                return breakpointMediaQueries(
                    theme,
                    maxWidths.map(mw =>
                        mw
                            ? css`
                                  max-width: ${mw}px;
                              `
                            : null,
                    ),
                );
            }}
        `,
    },
};

const styles = fullWidthContentAreaStyles;

const FullWidthContentArea: React.FC<Props> = ({ id, fields }) => {
    const containerStyle = {
        css: css`
            ${styles.container?.css || ""}
            background-color: ${fields.backgroundColor};
        `,
    };

    return (
        <StyledWrapper {...containerStyle}>
            <StyledWrapper {...styles.wrapper}>
                <Zone contentId={id} zoneName="Content" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(FullWidthContentArea)),
    definition: {
        group: "Basic",
        icon: "Banner",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.backgroundColor,
                editorTemplate: "ColorPickerField",
                displayName: "Background Color",
                defaultValue: "white",
            },
        ],
    },
};

export default widgetModule;
